<template>
  <field-label :label="label" :required="required" :hide-required="hideRequired">
    <v-select
      :class="customClass"
      :placeholder="computedPlaceholder"
      :outlined="$attrs.outlined ?? false"
      :dense="$attrs.dense ?? false"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      :rules="computedRules"
      :multiple="multiple"
      :return-object="returnObject"
      :value="value"
      :clearable="clearable"
      v-on="$listeners"
      v-bind="$attrs"
      :append-icon="appendIcon"
      :prepend-icon="prependIcon"
      :hide-details="hideDetails"
      :chips="chips"
      :disabled="disabled"
      no-data-text="Nenhum dado encontrado"
    >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope" /></template>
    </v-select>
  </field-label>
</template>

<script>
import FieldLabel from './FieldLabel.vue'
export default {
  name: 'TextField',
  components: { FieldLabel },
  computed: {
    computedPlaceholder() {
      return this.placeholder ?? this.label
    },
    computedRules() {
      const rules = []
      if (this.required) {
        rules.push(this.$validation.required())
      }
      rules.push(...(this.rules ?? []))
      return rules
    },
  },
  props: {
    value: undefined,
    label: String,
    required: Boolean,
    hideRequired: Boolean,
    placeholder: String,
    multiple: Boolean,
    itemText: [String, Function],
    itemValue: [String, Function],
    items: Array,
    returnObject: Boolean,
    clearable: Boolean,
    appendIcon: String,
    prependIcon: String,
    hideDetails: Boolean,
    chips: Boolean,
    disabled: Boolean,
    customClass: {} || String,
  },
}
</script>

<style scoped>
:deep(.v-select__slot) {
  padding: 0;
}
:deep(.v-select__selections) {
  gap: 4px;
}
</style>
